module.exports = __webpack_public_path__ + "img/ES1485.65513336.png";